import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  email: null,
  bitcoinAddress: "0",
  amountToken: null,
  tokenToday: null,
  statistics: null,
  isLoading: false,
  error: null,
};

export const userDataSlice = createSlice({
  name: 'userData',
  initialState,
  reducers: {
    userRequest(state, action) {
      state.email = null;
      state.bitcoinAddress = null;
      state.amountToken = null;
      state.tokenToday = null;
      state.isLoading = true;
      state.error = null;
    },

    userFailure(state, action) {
      state.email = null;
      state.bitcoinAddress = null;
      state.amountToken = null;
      state.tokenToday = null;
      state.isLoading = false;
      state.error = action.payload;
    },

    userSuccess(state, action) {
      state.email = action.payload.email;
      state.bitcoinAddress = action.payload.bitcoin_address;
      state.amountToken = action.payload.amount_token;
      state.tokenToday = action.payload.token_today;
      state.isLoading = false;
      state.error = null;
    },

    setStatistics(state, action) {
      state.statistics = action.payload;
    },

    setBitcoinAddress(state, action) {
      state.bitcoinAddress = action.payload.bitcoin_address;
    },
  },

});

export const { 
  userRequest, 
  userFailure, 
  userSuccess,
  setBitcoinAddress,
  setStatistics
} = userDataSlice.actions;


export default userDataSlice.reducer;
